<template>
    <span
        :class="`typo ${name || 'body-16-normal'} ${withIcon ? 'with-icon' : ''}`"
        @click="$emit('click')"
    >
        <slot></slot>
    </span>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    props: ["name", "withIcon"],
});
</script>

<style lang="sass" scoped>
.typo
    transition: color .15s ease

// body

.body-10-normal
    font-style: normal
    font-weight: normal
    font-size: 10px
    line-height: 13px

.body-12-light
    font-style: normal
    font-weight: 300
    font-size: 12px
    line-height: 15px

.body-12-normal
    font-style: normal
    font-weight: normal
    font-size: 12px
    line-height: 15px

.body-12-medium
    font-style: normal
    font-weight: 500
    font-size: 12px
    line-height: 15px

.body-12-bold
    font-style: normal
    font-weight: bold
    font-size: 12px
    line-height: 13px

.body-14-light
    font-style: normal
    font-weight: 300
    font-size: 14px
    line-height: 20px

.body-14-normal
    font-style: normal
    font-weight: normal
    font-size: 14px
    line-height: 20px

.body-14-medium
    font-style: normal
    font-weight: 500
    font-size: 14px
    line-height: 20px

.body-16-light
    font-style: normal
    font-weight: 300
    font-size: 16px
    line-height: 20px
    +r(480)
        font-size: 14px
        line-height: 1.25

.body-16-medium
    font-style: normal
    font-weight: 500
    font-size: 16px
    line-height: 20px
    +r(480)
        font-size: 14px
        line-height: 1.25

.body-16-normal
    font-style: normal
    font-weight: normal
    font-size: 16px
    line-height: 20px
    +r(480)
        font-size: 14px
        line-height: 1.25

.body-17-medium
    font-style: normal
    font-weight: 500
    font-size: 17px
    line-height: 20px
    +r(480)
        font-size: 15px
        line-height: 1.15

.body-18-bold
    font-style: normal
    font-weight: bold
    font-size: 18px
    line-height: 22px
    +r(480)
        font-size: 16px
        line-height: 1.35

// menu

.menu-12-bold
    font-style: normal
    font-weight: bold
    font-size: 12px
    line-height: 15px
    text-transform: uppercase

.menu-14-normal
    font-style: normal
    font-size: 14px
    line-height: 15px

.menu-16-normal
    font-style: normal
    font-size: 16px
    line-height: 15px
    text-transform: uppercase

// title

.title-18-bold
    font-style: normal
    font-weight: bold
    font-size: 18px
    line-height: 25px

.title-30-normal
    font-style: normal
    font-weight: normal
    font-size: 30px
    line-height: 1

    +r(480)
        display: block
        font-size: 28px
        line-height: 1.1

.title-30-bold
    font-style: normal
    font-weight: bold
    font-size: 30px
    line-height: 30px


// link

.link
    cursor: pointer
    &:hover
        text-decoration: underline

// Options

.with-icon
    display: flex
    &:hover
        text-decoration: none
    .icon
        margin-top: 5px
        margin-right: 5px

// CC

.cc-body, .ci-body
    font-style: normal
    font-weight: 300
    font-size: 14px
    line-height: 20px

.cc-body-italic, .ci-body-italic
    font-style: italic
    font-weight: 300
    font-size: 14px
    line-height: 20px

.cc-h1
    font-style: normal
    // font-weight: bold
    font-weight: 400
    font-size: 30px
    line-height: 48px
    letter-spacing: 1px

.cc-h2
    font-style: normal
    font-weight: bold
    font-size: 35px
    line-height: 40px

.cc-h3
    font-style: normal
    font-weight: bold
    font-size: 26px
    line-height: 25px

.cc-h4
    font-style: normal
    font-weight: bold
    font-size: 16px
    line-height: 25px
    text-decoration: underline

@media print
    .cc-body
        ::v-deep p:last-child
            margin-bottom: 0

    .title-30-normal
        display: block
        margin: 5mm 0 2.5mm
        color: #381A01
        font-size: 20pt !important
        font-weight: 300 !important
        letter-spacing: 0.01em !important
        line-height: 1 !important
        text-align: left

    .body-16-light
        display: block
        font-size: 12pt
        line-height: 1.25
</style>
